import logo from '../../assets/images/logo22.png';
import { LoginDiv, Warper, Logo, LoginImage, Title } from './Login.style';
import LoginForm from '../../components/LoginForm/LoginForm';
import img from './../../assets/images/loginbg.png';
import foreign from './../../assets/images/foriegnlogo.png';
import { useEffect, useState } from 'react';
import axiosInstance from '../../core/axiosInstance';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
	const [hasToken, setHasToken] = useState<boolean>(false);
  useEffect(() => {
    axiosInstance
      .get('/check-expired')
      .then()
      .catch((err) => {
        if (err.response.status === 400 && !err.response.license) {
          toast.error(err.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            toastId: 'uniqueId',
          });
          navigate('/expired');
        }
      });
		setHasToken(searchParams.has('token') && process.env.REACT_APP_TOKEN === searchParams.get('token') ? true : false);

  }, []);
  if (!hasToken) {
		return <div className='h-100 bg-white w-100 absolute right-0'></div>;
	}
  return (
    <Warper>
      <LoginDiv>
        <div className="formContainer">
          <Logo src={logo} alt="logo" />
          <LoginForm />
        </div>
        <div className="for-logo">
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
        </div>
      </LoginDiv>
      <LoginImage>
        <img src={img} alt="" />
      </LoginImage>
    </Warper>
  );
};

export default Login;
